import { PhotoEntity } from '@interpals/api-web';
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const uploadPhoto = createAsyncThunk<PhotoEntity, File>('photo/upload', async (file, { rejectWithValue }) => {
    const data = await api.createPhoto({ file }).catch(async (error) => rejectWithValue(await error.json()));

    return data as unknown as PhotoEntity;
});
